var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"pc-back-link",attrs:{"id":_vm.id,"data-id":_vm.dataId},on:{"click":function($event){return _vm.$emit('click')}}},[_c('pc-icon',{staticClass:"pc-back-link-icon",attrs:{"name":"pc-angle-left","size":"12","color":_vm.$colors.penChecksTeal}}),_c('span',[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }